import { Fragment, useState } from 'react';
import styled from '@emotion/styled';
import { Table } from 'semantic-ui-react';
import { ExpandButton } from '@britishcouncil/react-admin';
import { testCentreOverviewStore } from 'store';
import { TestCentreOverviewQueryFilters } from 'store/test-centre-overview/service';
import { COLUMN_ORDER, getDistrictCellContent } from './table-columns';
import { TestCentreOverviewSessionRows } from './TestCentreOverviewSessionRows';
import { LoadingRow } from './LoadingRow';

export const TestCentreOverviewDistrictRows = ({
  centreId,
  date,
  filters,
}: {
  centreId: number | undefined;
  date: string;
  filters: TestCentreOverviewQueryFilters;
}) => {
  const { data: districts, isFetching } =
    testCentreOverviewStore.service.useGetTestCentreOverviewDistrictsForDateQuery(
      { centreId, date, filters },
      { skip: !centreId }
    );
  const [expandedDistrictIds, setExpandedDistrictIds] = useState<Set<number>>(new Set());

  const toggleDistrict = (districtId: number) =>
    setExpandedDistrictIds((prev) => {
      const next = new Set(prev);

      if (next.has(districtId)) {
        next.delete(districtId);
      } else {
        next.add(districtId);
      }

      return next;
    });

  if (isFetching) {
    return <LoadingRow colSpan={COLUMN_ORDER.length} label="Loading..." />;
  }

  return (
    <>
      {(districts ?? []).map((district) => {
        const isOpen = expandedDistrictIds.has(district.districtId);
        return (
          <Fragment key={district.districtId}>
            <Table.Row>
              {COLUMN_ORDER.map((key) =>
                key === 'date' ? (
                  <Table.Cell key={key}>
                    <S.DistrictCell>
                      <ExpandButton
                        open={isOpen}
                        onClick={() => toggleDistrict(district.districtId)}
                        size="mini"
                        secondary={false}
                        color="blue"
                        style={{ margin: 0 }}
                      />
                      {district.districtName}
                    </S.DistrictCell>
                  </Table.Cell>
                ) : (
                  <Table.Cell key={key}>{getDistrictCellContent(key, district)}</Table.Cell>
                )
              )}
            </Table.Row>
            {isOpen && (
              <TestCentreOverviewSessionRows
                centreId={centreId}
                date={date}
                districtId={district.districtId}
                filters={filters}
              />
            )}
          </Fragment>
        );
      })}
    </>
  );
};

const S = {
  DistrictCell: styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-left: 1.5rem;
    white-space: nowrap;
  `,
};
